import moment from 'moment/moment';

import { DealSheetRulesFilterType } from './types';
import { DealSheetRulesFilters } from './filters/cards';

export const initialDealSheetRulesFiltersValue: DealSheetRulesFilters = {
  [DealSheetRulesFilterType.CREATE_DATE_RANGE]: {
    to: moment(),
    from: moment().subtract(5, 'years'),
  },
  [DealSheetRulesFilterType.CUSTOMER_TYPE]: [],
  [DealSheetRulesFilterType.PAYMENT_TYPE]: [],
  [DealSheetRulesFilterType.EQUIPMENT_TYPE]: [],
  [DealSheetRulesFilterType.STATE]: [],
  [DealSheetRulesFilterType.COUNTRY]: [],
  [DealSheetRulesFilterType.PROVINCE]: [],
};
